import React, { useState, useEffect }  from "react";
import { useParams, Link } from 'react-router-dom';
import Navigation from "../Navigation";
import ArticlesImg from "./../../images/articles.jpg";
import { getWithExpiry, setWithExpiry } from '../../common';
import {Helmet} from "react-helmet";
import configVars from "../../config";
import HorizontalNav from "../Dashboard/HorizontalNav";

const SingleArticles = () => {

    const { categoryslug, post_id } = useParams();
    const [postTitle, setPostTitle] = useState('');
    const [postContent, setPostContent] = useState('');
    const [postImage, setPostImage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [childCat, setChildCat] = useState('');


	useEffect(() => {

        const savedPostData = getWithExpiry( `sy_post_${post_id}_data`);

        if ( savedPostData ) {

            setPostTitle(savedPostData.post_title);
            setPostContent(savedPostData.post_content);
            setPostImage(savedPostData.post_thumbnail);   

        } else {

            setIsLoading(true);

            (async () => {

                const response = await fetch(
                    `${configVars.apiUrl}sustainchange/v1/getpostsbyid/?postid=${post_id}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                    }
                );
    
                const postResponse = await response.json();
    
                if ( postResponse ) {

                    if ( postResponse.success === true ) {

                        setWithExpiry( `sy_post_${post_id}_data`, postResponse.data );
                        setPostTitle(postResponse.data.post_title);
                        setPostContent(postResponse.data.post_content);
                        setPostImage(postResponse.data.post_thumbnail); 

                    }

                    //console.log( postResponse.data.updated_content );

					setIsLoading(false);
                    
                }
    
            })()

        }

		

	}, [post_id]);

    useEffect(() => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.get("cat") && urlParams.get("cat").length > 0 ) {
            const cat = urlParams.get("cat");

            setChildCat(cat);
        }

    }, []);
  
    return (
		<div className="main-wrapper">
			<Helmet>
				<title>{postTitle} - KUNSKAP & INSPIRATION</title>
				<meta name="description" content="" />
			</Helmet>
            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="KUNSKAP & INSPIRATION" />

                <div className="pt-5 pt-lg-0 page-content-inner">
                    <div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px'}}>
                        { isLoading &&
                            <img src={ArticlesImg} alt="te" className="w-100" style={{objectFit: 'cover'}} />
                        }
                            { !isLoading && postImage &&
                            <img src={postImage} alt="te" className="w-100" style={{objectFit: 'cover'}} />
                            }
                        <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column dark-overlay">
                            <div className="flex-grow-1 d-flex align-items-center">
                                <h2 className="text-white display-6 text-center text-shadow single-article-title">{postTitle.replaceAll('&amp;', '&')}</h2>
                            </div>
                            <span className="text-white p-3 d-flex w-100 dark-overlay">
                                <span className="text-white pe-3"><i className="fa fa-long-arrow-left" aria-hidden="true"></i></span>
                                <Link to={`/kunskap-inspiration/${categoryslug}/${childCat ? childCat : ''}`} className="text-white">Gå tillbaka</Link>
                            </span>
                        </div>
                    </div>

                    <div className="row g-0">
                        <div className="col-12 px-4 pt-5 pb-6 single-article-wrap">

                            { isLoading &&
                                <div className="d-flex justify-content-center mt-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            }

                            {postContent && !isLoading &&
                                <div className="mx-auto text-lg" style={{maxWidth: '750px'}} dangerouslySetInnerHTML={{__html: postContent}}></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
		</div>
    );
};

export default SingleArticles;
